export default {
  CLIENT_INFO: 'CLIENT_INFO',
  CONTRACTS: 'CONTRACTS',
  DOCUMENT: 'DOCUMENT',
  NOTES: 'NOTES'
};
